var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg90(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        .st13{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\r\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.39,19.55h5.34v4.15c0,0,9.39,1.01,8.8,13.17c0,0-1.68,12.26-15.52,9.39c0,0-11.47-5.09-6.72-16.04 c0,0,1.98-5.56,7.71-6.52v-4.15H28.39z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 30.77,
    cy: 35.07,
    r: 9.39
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.87,
    y: 2.31,
    width: 7.12,
    height: 1.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55,4.65h4.15c0,0-0.3,2.97,2.17,3.56h15.81c0,0,5.14,1.09,4.15,6.92h-3.76c0,0-0.59-2.87-2.97-2.87H11.99 C11.99,12.26,6.75,11.37,6.55,4.65z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 16.21,
    width: 5.73,
    height: 2.08
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.4,18.29 36.4,17.25 39.17,17.25 39.17,20.95 36.4,20.95 36.4,19.55 34.72,19.55 34.72,18.29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.18,
    y: 27.79,
    width: 1.58,
    height: 1.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.85,
    y: 28.58,
    transform: "matrix(0.8001 -0.5998 0.5998 0.8001 -12.0921 22.4475)",
    width: 1.58,
    height: 1.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.69,
    y: 31.1,
    transform: "matrix(0.4155 -0.9096 0.9096 0.4155 -14.1116 41.8164)",
    width: 1.58,
    height: 1.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.98,
    y: 33.91,
    width: 1.58,
    height: 1.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.28,
    y: 28.58,
    transform: "matrix(0.5957 -0.8032 0.8032 0.5957 -9.8119 39.2447)",
    width: 1.58,
    height: 1.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.69,
    y: 37.22,
    transform: "matrix(0.8585 -0.5128 0.5128 0.8585 -15.8843 18.443)",
    width: 1.58,
    height: 1.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.5,
    y: 31.1,
    transform: "matrix(0.8707 -0.4919 0.4919 0.8707 -10.992 21.9722)",
    width: 1.58,
    height: 1.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.29,
    y: 34.28,
    width: 1.58,
    height: 1.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.5,
    y: 37.19,
    transform: "matrix(0.4969 -0.8678 0.8678 0.4969 -14.7053 50.5972)",
    width: 1.58,
    height: 1.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.74,
    y: 40.49,
    width: 4.22,
    height: 1.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.11,36.24l1.63-0.94c0,0-0.05-2.7,2.77-2.36c0,0,2.17,0.32,1.46,2.92c0,0-1.11,2.01-3.43,0.78L28,37.52L27.11,36.24z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 31.04,
    cy: 34.99,
    r: 1.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg90);
export default __webpack_public_path__ + "static/media/90.ce891828aa23dd827bf89fe8a6d14276.svg";
export { ForwardRef as ReactComponent };